import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { AccountService } from "@/services/AccountService"
import { getAccountContacts } from "./getAccountContacts"
import { MeterpointService } from "@/services/MeterpointService"
import { ImbpAccount } from "@/models/imbpAccount/imbpAccount"
import { IImbpAccount } from "@/models/imbpAccount/imbpAccount.types"

export const getImbpAccount = (accountNumber: string) => {
  const queries = new QueryAggregator()
  const contactQuery = getAccountContacts(accountNumber)
  const accountQuery = AccountService.getAccount(accountNumber)
  const coreIdQuery = AccountService.getCoreIdByAccountNumber(accountNumber)
  const meterpointQuery = MeterpointService.getForAccount(accountNumber)

  queries.add(contactQuery)
  queries.add(accountQuery)
  queries.add(coreIdQuery)
  queries.add(meterpointQuery)

  const primaryContact = contactQuery.data.find(
    (contact) => contact.juniferPrimaryContact,
  )

  const accountAddress = accountQuery.data.supplyAddress

  const data: IImbpAccount = new ImbpAccount(
    coreIdQuery.data,
    primaryContact,
    accountAddress,
    meterpointQuery.data,
  )

  return queries.setData(data).getAggregate()
}
